export default "__VITE_ASSET__c9822dd9__"